import { render, staticRenderFns } from "./Play_Comment.vue?vue&type=template&id=4fd45656&scoped=true"
import script from "./Play_Comment.vue?vue&type=script&lang=js"
export * from "./Play_Comment.vue?vue&type=script&lang=js"
import style0 from "./Play_Comment.vue?vue&type=style&index=0&id=4fd45656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd45656",
  null
  
)

export default component.exports